// extracted by mini-css-extract-plugin
module.exports = {"loadingPage":"LoadingPage_loadingPage__ar0MP"};